import { jsx as _jsx } from "react/jsx-runtime";
import React, { createElement, useEffect, useCallback } from 'react';
import { transform } from 'js/css-transform';
import HTML from 'html-parse-stringify';
import _, { find as _find, includes as _includes } from 'lodash';
import he from 'he';
const forbiddenTags = ['script', 'iframe', 'object'];
const PreviewEditableFTs = ({ id, attributes, params, children, setFontSizeSettings, name: Tag, }) => {
    const extractClassFromHTML = useCallback((htmlString) => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlString;
        const spanElements = tempElement.querySelectorAll('span');
        if (spanElements.length > 0) {
            const lastSpan = spanElements[spanElements.length - 1];
            const classList = lastSpan.className;
            const classes = classList.split(' ');
            return classes.find((className) => className.startsWith('text-'));
        }
        return undefined;
    }, []);
    /** content Parser */
    const loop = useCallback((elements) => {
        const result = [];
        const voidElements = [
            'area',
            'base',
            'br',
            'col',
            'embed',
            'hr',
            'img',
            'input',
            'keygen',
            'link',
            'meta',
            'param',
            'source',
            'track',
            'wbr',
        ];
        _.forEach(elements, (value, key) => {
            if (value.type === 'text') {
                result.push(he.decode(value.content));
            }
            else if (value.type === 'tag' && !_includes(forbiddenTags, value.name)) {
                let { name } = value;
                const attributes = { key };
                _.forEach(value.attrs, (attr, attrKey) => {
                    switch (attrKey) {
                        case 'class':
                            attributes.className = attr;
                            break;
                        case 'contenteditable':
                            attributes.contentEditable = attr;
                            break;
                        case 'colspan':
                            attributes.colSpan = attr;
                            break;
                        case 'rowspan':
                            attributes.rowSpan = attr;
                            break;
                        case 'style':
                            if (attr) {
                                try {
                                    attributes[attrKey] = transform(attr);
                                }
                                catch (_a) {
                                    /* ignore */
                                }
                            }
                            break;
                        default:
                            attributes[attrKey] = attr;
                            break;
                    }
                });
                if (name === 'html' || name === 'head' || name === 'body') {
                    name = 'div';
                }
                if (_.includes(voidElements, name)) {
                    result.push(createElement(name, Object.assign({}, attributes)));
                }
                else if (attributes['data-is-root']) {
                    result.push(...loop(value.children));
                }
                else {
                    result.push(createElement(name, Object.assign({}, attributes), loop(value.children)));
                }
            }
        });
        return result;
    }, []);
    /** get content as react-elements */
    const getContent = useCallback(() => {
        const param = _find(params, ['name', attributes['data-name']]);
        if (param) {
            return loop(HTML.parse('<div data-is-root="true">' + param.value + '</div>'));
        }
        return loop(children);
    }, [params, attributes, children, loop]);
    /** componentDidMount */
    useEffect(() => {
        if (attributes['data-fontsize-section']) {
            let sectionFontSize = attributes['data-fontsize-section'];
            let source = '';
            if (params.length > 0) {
                _.forEach(params, (param) => {
                    var _a;
                    if (attributes['data-name'] === param.name) {
                        source = param.value;
                        sectionFontSize = (_a = extractClassFromHTML(source)) !== null && _a !== void 0 ? _a : sectionFontSize;
                    }
                });
            }
            setFontSizeSettings(id, sectionFontSize);
        }
    }, [attributes, id, params, extractClassFromHTML, setFontSizeSettings]);
    return (_jsx(Tag, Object.assign({}, attributes, { contentEditable: false, children: _jsx("div", { children: getContent() }) })));
};
export default PreviewEditableFTs;
